import React from "react"
import Image from "gatsby-image"
import styles from "./responsiveImage.module.scss"

const ResponsiveImage = props => <Image className={styles.wrapper} {...props} />

export default ResponsiveImage
